import axios from 'axios';
import i18n from '@/i18n.js';
import store from '@/store/';
import { db, storage, functions } from '@/firebase';
import { pointInPolygon } from '@/utils/funciones_auxiliares.js';

export default {
    getListadoRestaurantes({ commit, state, rootState }) {
        let codigoProvincia = rootState.pedido.addressObject.codigoProvincia;
        if (codigoProvincia) {
            return db.collection('restaurantes')
                .where('codigoProvincia', '==', codigoProvincia)
                .get()
                .then((r) => {
                    let res = [];
                    if (!r.empty) {
                        r.docs.forEach(rest => {
                            res.push({
                                ...rest.data(),
                                id: rest.id
                            })
                        });
                    }

                    commit('setListadoRestaurantes', res)
                    return res;
                })
        }

    },
    getListadoNegocios({ commit, state, rootState }) {
        let codigoProvincia = rootState.pedido.addressObject.codigoProvincia;

        return db.collection('negocios')
            .where('provincias', 'array-contains', codigoProvincia)
            .get()
            .then((r) => {
                let res = [];
                if (!r.empty) {
                    r.docs.forEach(rest => {
                        let aux = rest.data();
                        aux.id = rest.id;
                        res.push(aux);
                    });
                }
                return res;
            })
            .then((res) => {
                var actions = res.map(function (item) {
                    var storageRef = storage.ref('imagenes/negocios/' + item.id + '.jpg');
                    var storageRef2 = storage.ref('imagenes/negocios/' + item.id + '_listado.jpg');
                    var p1 = storageRef.getDownloadURL()
                        .then((r) => {
                            item.imagen = r;
                            return item;
                        })
                        .catch((e) => {
                            item.imagen = false;
                            return item;
                        })
                    var p2 = storageRef2.getDownloadURL()
                        .then((r) => {
                            item.imagenListado = r;
                            return item;
                        })
                        .catch((e) => {
                            item.imagenListado = false;
                            return item;
                        })
                    return Promise.all([p1, p2])
                        .then((r) => { return item })
                });
                return Promise.all(actions)
                    .then((r) => {
                        commit('setListadoNegocios', r)
                    })
                    .catch((e) => {
                        console.log(e);
                    })
            })
    },
    //mezcla restaurantes y negocios en un sólo objeto
    getListadoRestNegMix({ commit, dispatch, state, rootState }) {
        let codigoRest = state.listadoRestNegMix.length > 0 ? state.listadoRestNegMix[0].codigoProvincia : null;
        let codigoProvincia = rootState.pedido.addressObject.codigoProvincia != undefined ? rootState.pedido.addressObject.codigoProvincia : null;

        //Si ya estan cargados los restaurantes de esa provincia no repite llamada
        if (codigoProvincia != codigoRest) {
            return Promise.all([
                dispatch('getListadoRestaurantes'),
                dispatch('getListadoNegocios')
            ])
                .then((res) => {
                    let n = state.listadoNegocios;
                    let r = state.listadoRestaurantes;

                    let devolver = [];
                    r.forEach((rest) => {
                        let found = n.find((e) => e.id == rest.negocio);
                        if (found) {
                            rest.nombreRest = rest.nombre;
                            rest.idRest = rest.id;
                            rest.mapeoNeoRest = rest.mapeoNeo;
                            let aux = { ...rest, ...found };
                            devolver.push(aux);
                        }
                    });

                    if (devolver.length == 0) {
                        commit("snackbar/setMensajeDanger",
                            { msj: "No se localizan restaurantes por la zona" },
                            { root: true }
                        );
                    }


                    commit('setListadoRestNegMix', devolver)
                })
        } else {
            console.log("no hace falta cargar restaurantes")
        }
    },
    getRestNegocio({ state, commit, rootState }) {
        let n = rootState.pedido.negocioPedido;
        let r = rootState.pedido.restaurantePedido;
        console.log(r);
        var p_n = db.collection('negocios').doc(n).get()
            .then((res) => {
                if (res.exists) {
                    let dataNegocio = res.data();
                    dataNegocio.id = res.id;
                    return dataNegocio;
                } else {
                    alert("OK");
                }
            })
            .then((negocio) => {
                var storageRef = storage.ref('imagenes/negocios/' + negocio.id + '.jpg');
                var storageRef2 = storage.ref('imagenes/negocios/' + negocio.id + '_listado.jpg');
                var p1 = storageRef.getDownloadURL()
                    .then((r) => {
                        negocio.imagen = r;
                        return negocio;
                    })
                    .catch((e) => {
                        negocio.imagen = false;
                        return negocio;
                    })
                var p2 = storageRef2.getDownloadURL()
                    .then((r) => {
                        negocio.imagenListado = r;
                        return negocio;
                    })
                    .catch((e) => {
                        negocio.imagenListado = false;
                        return negocio;
                    })
                return Promise.all([p1, p2]).then(() => { return negocio })
            })
            .then((r) => {
                console.log(r)
                commit('pedido/setNegocioObjPedido', r, { root: true });
                return r
            })

        var p_r = db.collection('restaurantes').doc(r).get()
            .then((res) => {
                console.log(res);
                if (res.exists) {
                    let dataRestaurante = res.data();
                    dataRestaurante.id = res.id;
                    commit('pedido/setRestauranteObjPedido', dataRestaurante, { root: true });
                    return dataRestaurante;
                } else {
                    commit('pedido/setRestaurantePedido', '');
                    commit('pedido/setRestauranteObjPedido', {
                        imagenListado: "",
                        nombre: "",
                        imagen: ""
                    }, { root: true });
                    return Promise.reject("error en restaurante")
                }
            })

        return Promise.all([p_n, p_r])
            .then((r) => {
                let modoFuncionamiento = "standalone";
                if (r[1].mapeoNeo != undefined && r[1].mapeoNeo) {
                    modoFuncionamiento = "standalone";//A extinguir "neoMix";
                } else {
                    modoFuncionamiento = "standalone";
                }

                commit("config/setModoFuncionamiento", modoFuncionamiento, { root: true })
                return modoFuncionamiento;
            })
            .catch(() => {
                dispatch('pedido/resetPedido', {}, { root: true })
                    .then(() => rootState.app.router.push('/'))
            })
    },
    getRestNegocioParametros({ commit }, payload) {
        let n = payload.negocio;
        let r = payload.rest;
        var p_n = db.collection('negocios').doc(n).get()
            .then((res) => {
                if (res.exists) {
                    let dataNegocio = res.data();
                    dataNegocio.id = res.id;
                    return dataNegocio;
                }
            })
            .then((negocio) => {
                var storageRef = storage.ref('imagenes/negocios/' + negocio.id + '.jpg');
                var storageRef2 = storage.ref('imagenes/negocios/' + negocio.id + '_listado.jpg');
                var p1 = storageRef.getDownloadURL()
                    .then((r) => {
                        negocio.imagen = r;
                        return negocio;
                    })
                    .catch((e) => {
                        negocio.imagen = false;
                        return negocio;
                    })
                var p2 = storageRef2.getDownloadURL()
                    .then((r) => {
                        negocio.imagenListado = r;
                        return negocio;
                    })
                    .catch((e) => {
                        negocio.imagenListado = false;
                        return negocio;
                    })
                return Promise.all([p1, p2]).then(() => { return negocio })
            })
            .then((r) => {
                return r
            })

        var p_r = db.collection('restaurantes').doc(r).get()
            .then((res) => {
                if (res.exists) {
                    let dataRestaurante = res.data();
                    dataRestaurante.id = res.id;
                    return dataRestaurante;
                }
            })
            .catch((e) => {
                console.log(e);
            })

        return Promise.all([p_n, p_r])
            .then((r) => {
                console.log(r);
                /*return {
                    ...r[1],
                    ...r[0],
                    idRest: r[1].id,
                    nombreRest: r[1].nombre
                };*/
                return r;
            })
    },

    //Productos para pedidos online
    getProductosCategorias({ state, commit, rootState }) {
        let n = rootState.pedido.negocioPedido;
        let r = rootState.pedido.restaurantePedido;
        var productos = db.collection('negocios').doc(n).collection('productos')
            .get()
            .then((r) => {
                let res = [];
                let docs = r.docs;
                docs.forEach(e => {
                    let d = e.data();
                    d.id = e.id;
                    res.push(d);
                });
                return res;
            })
            .then((res) => {
                var actions = res.map(function (item) {
                    var storageRef = storage.ref('imagenes/productos/' + item.id + '.jpg');
                    //var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
                    return storageRef.getDownloadURL()
                        .then((r) => {
                            item.imagen = r;
                            return item;
                        })
                        .catch(() => {
                            item.imagen = false;
                            return item;
                        })
                });
                Promise.all(actions)
                    .then((r) => {
                        commit('restaurante/setAllProducts', r, { root: true })
                    })
            });
        let categorias = db.collection('negocios').doc(n).collection('categorias')
            .get()
            .then((r) => {
                let res = [];
                let docs = r.docs;
                docs.forEach(e => {
                    let d = e.data();
                    d.id = e.id;
                    res.push(d);
                });
                commit('restaurante/setCategorias', res, { root: true })
            });
        var descuentos = db.collection('negocios').doc(n).collection('descuentos')
            .get()
            .then((r) => {
                let res = [];
                let docs = r.docs;
                docs.forEach(e => {
                    let d = e.data();
                    d.id = e.id;
                    res.push(d);
                });
                commit('restaurante/setDescuentos', res, { root: true })
            });
        var impuestos = db.collection('impuestos')
            .get()
            .then((r) => {
                let res = [];
                let docs = r.docs;
                docs.forEach(e => {
                    let d = e.data();
                    d.id = e.id;
                    res.push(d);
                });
                commit('restaurante/setImpuestos', res, { root: true })
            });
        return Promise.all([productos, categorias, descuentos, impuestos])
    },
    getProductosNeoTPV({ state, commit, rootState }) {
        var productosNeo = functions.httpsCallable('httpNeoGetProducts');
        return productosNeo(rootState.pedido.restauranteObjPedido).then((r) => {
            commit('setProdBartolome', r.data);
        })
            .catch((e) => {
                console.log(e);
            })
    },
    //eesta acción pasa a módulo direcciones
    reorderRestaurants({ state, rootState, commit, dispatch }, data) {
        let _vue = this;
        let restaurantes = [];

        if (data != undefined) {
            restaurantes = data;
        } else {
            restaurantes = state.listadoRestaurantes;
        }

        if (restaurantes.length > 0) {

            return new Promise((resolve, reject) => {
                let dist = [];
                let position = rootState.pedido.addressObject.coordenadas;

                commit('setListadoRestaurantes', [])
                restaurantes.forEach(function (e, i) {
                    let payload = {
                        lat1: position[0],
                        lon1: position[1],
                        lat2: e.latitud,
                        lon2: e.longitud
                    }
                    store.dispatch('pedido/getDistanceLatLonInKm', payload)
                        .then((e) => {
                            restaurantes[i].distancia = e;
                        })
                })

                resolve(restaurantes)
            })

        } else {
            return restaurantes;
        }
    },
    cargaDatosComunes({ dispatch }) {
        return Promise.all([
            dispatch('getCocinas'),
            dispatch('getImpuestos'),
            dispatch('getCaracteristicas')
        ])
    },
    getCocinas({ commit }) {
        let devolver = [];
        return db.collection('tipococinas').get()
            .then((res) => {
                res.forEach(doc => {
                    let aux = doc.data();
                    aux.id = doc.id;
                    devolver.push(aux);
                });

                commit('setCocinas', devolver)
            })
    },
    getImpuestos({ commit }) {
        let devolver = [];
        return db.collection('impuestos').get()
            .then((res) => {
                res.forEach(doc => {
                    let aux = doc.data();
                    aux.id = doc.id;
                    devolver.push(aux);
                });

                commit('setImpuestos', devolver)
            })
    },
    getCaracteristicas({ commit }) {
        return db.collection('caracteristicas')
            .get()
            .then((r) => {
                let res = [];
                let docs = r.docs;
                docs.forEach(e => {
                    let d = e.data();
                    d.id = e.id;
                    res.push(d);
                });
                return res
            })
            .then((r) => {
                var actions = r.map(function (item) {
                    var storageRef = storage.ref('imagenes/caracteristicas/' + item.id + '.jpg');
                    //var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
                    return storageRef.getDownloadURL()
                        .then((r) => {
                            item.imagen = r;
                            return item;
                        })
                        .catch(() => {
                            item.imagen = false;
                            return item;
                        })
                });
                return Promise.all(actions)
                    .then((r) => {

                        commit('restaurante/setCaracteristicas', r, { root: true })
                    })
                    .catch((e) => {
                        console.log("error", e);
                    })
            })
    },
    filtradoRestaurantesDomicilio({ state, rootState, commit, dispatch }) {
        let res = [];
        let _vue = this;

        let direccionPedido = rootState.pedido.direccionPedido;
        let restaurants = (state.listadoRestaurantes).filter(e => e.zonasReparto);
        let id = 0;
        let activado = false;
        let minimo = 0;
        let recargo = 0;
        let inPolygon = false;
        let restaurantsPosibles = [];

        if (restaurants.length > 0 && direccionPedido.coordenadas != undefined) {
            console.log("dentro");
            restaurants.forEach((e) => {
                id = e.id

                e.zonasReparto.forEach((e1) => {
                    activado = e1.siDomicilio;
                    minimo = e1.domicilioMinimo;
                    recargo = e1.domicilioRecargo;
                    if (activado) {
                        inPolygon = pointInPolygon([direccionPedido.coordenadas[0], direccionPedido.coordenadas[1]], e1.poligono);
                        console.log(inPolygon);
                        if (inPolygon) {
                            let alreadyIn = restaurantsPosibles.findIndex(e => e.id == id)
                            if (alreadyIn > -1) {
                                console.log(minimo);
                                if (parseFloat(minimo) < restaurantsPosibles[alreadyIn].minimo) {
                                    restaurantsPosibles[alreadyIn].minimo = parseFloat(minimo);
                                    restaurantsPosibles[alreadyIn].recargo = parseFloat(recargo);
                                }

                            } else {
                                e.minimo = parseFloat(minimo);
                                e.recargo = parseFloat(recargo);
                                restaurantsPosibles.push(e)
                            }
                        }
                    }
                })
            })
        }
        console.log(restaurantsPosibles)
        commit('setRestaurantesPosibles', restaurantsPosibles);
        return restaurantsPosibles
    }
}







